module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Help Us Help You!"])},
        "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["We’ll do our best to help you achieve your nutrition &amp;well-being goals"])},
        "beta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["✨ Join The Beta ✨"])}
      },
      "fr": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aidez-Nous À Vous Aider !"])},
        "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nous ferons notre maximum pour vuos aider à remplir vos objectifs de bien-être et de nutrition"])},
        "beta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["✨ Rejoignez la Beta ✨"])}
      }
    }
  })
  Component.options.__i18nBridge = Component.options.__i18nBridge || []
  Component.options.__i18nBridge.push('{"en":{"title":"Help Us Help You!","subtitle":"We’ll do our best to help you achieve your nutrition &amp;well-being goals","beta":"✨ Join The Beta ✨"},"fr":{"title":"Aidez-Nous À Vous Aider !","subtitle":"Nous ferons notre maximum pour vuos aider à remplir vos objectifs de bien-être et de nutrition","beta":"✨ Rejoignez la Beta ✨"}}')
  delete Component.options._Ctor
  
}
